export enum InputState {
  Current = 'Current',
  Pending = 'Pending',
  Confirmed = 'Confirmed',
  Rollback = 'Rollback',
  Suspended = 'Suspended',
}
